import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

const icon1 = "https://winpeforum.com/assets/elements/KrunaliShah.jpg";
const icon2 = "https://winpeforum.com/assets/elements/KhushbooShahani.png";
const icon3 = "https://winpeforum.com/assets/elements/RheaGrover.jpg";
const icon4 = "https://winpeforum.com/assets/elements/SapnaGoyal.jpg";
const icon5 = "https://winpeforum.com/assets/elements/SanjnaTulsiani.png";

let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.Speaker2 = [
     
  
  
        {
          imgUrl: icon5,
          desc: `<div>
      Sanjna has over 10 years of experience across venture growth investing, equity research and investor
relations. She is a Senior Vice President at Iron Pillar and has been part of the founding team since
2018. At Iron Pillar, she is involved in the entire deal lifecycle from sourcing, due diligence and
documentation to portfolio company monitoring and exit. Additionally, she contributes towards investor
relations and marketing.<br/><br/>
Sanjna is a CFA® Charter holder. She holds a Masters in Commerce (Finance & Accounting) and
Bachelors in Management Studies (Finance) from the University of Mumbai.

          </div>`,
          name: "Sanjna Tulsiani",
          post: `<div>Senior Vice President, Investments<br/>Iron Pillar
          </div>`,
        },
  ];
    this.Speaker1 = [
      {
          imgUrl: icon1,
          desc: `<div>
      Krunali Shah has been an Investor with A91 Partners for 5 years. She is involved with investments
across consumer brands, financial services and technology. Prior to joining A91, Krunali was a part of
the Boston Consulting Group. She has graduated from IIM Ahmedabad and is a Chartered Accountant.

          </div>`,
          name: "Krunali Shah Pinjani",
          post: `<div>Investor<br/> A91 Partners
          </div>`,
        },
        {
            imgUrl: icon2,
          desc: `<div>
      Khushboo Shahani is Executive Director at Eversource Capital, focusing on investments in energy
efficiency, resource efficiency, and e-mobility. With over 14 years of experience, she has managed
nearly USD 1 billion across private equity, credit, and special situations. Previously, she was VP at
Everstone Capital, deploying over USD 150 million, and Chief Manager at SBI Funds, handling
distressed assets. Khushboo holds an MBA from SP Jain Institute of Management & Research and a
B.Com from St. Francis College, Hyderabad.
          
          </div>`,
          name: "Khushboo Shahani",
          post: `<div>Executive Director<br/>Eversource Capital

          </div>`,
          },
          
          {
            imgUrl: icon3,
            desc: `At Warburg, Rhea spends most of her time looking at the Financial Services, FinTech and Consumer
sectors. Prior to joining Warburg, Rhea worked at L.E.K. Consulting, United Nations Development
Programme, and as a business head at a FinTech startup. She completed her Bachelor’s from Lady
Shri Ram College at Delhi University and MBA from The Wharton School at The University of
Pennsylvania.
             `,
            name: "Rhea Grover",
            post: `<div> Vice President<br/>Warburg Pincus
            </div>`,
          },
          {
            imgUrl: icon4,
            desc: `Sapna Goyal is a seasoned investor with over 12 years of experience in early and growth-stage tech startups
in India. At WaterBridge Ventures, she leads seed and pre-Series A investments in AI-SaaS and DeepTech.
Previously, she led M&A and Strategy at Udaan, raising $800M+ and driving key initiatives. She began her
career as a growth-stage tech investor at Goldman Sachs. Sapna holds an MBA from IIM Kozhikode and a
bachelor’s from Lady Shri Ram College. She is passionate about entrepreneurship, technology, and building a more inclusive investment ecosystem. 

    
             `,
            name: "Sapna Goyal",
            post: `<div>Vice President<br/> WaterBridge Ventures
            </div>`,
          },
         
          
    ];
 
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="Understanding PEVC Culture: Career Progression and Promotion Paths"
          image={"https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png"}
          description="Winpe Ignite sessions made a resounding comeback with the PEVC Career Talk Series on the 14th December 2024."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">PEVC Career Talk Series | Session 02<br/>Understanding PEVC Culture: Career Progression and Promotion Paths</div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                  <span>May 17, 2025</span>
                  <br/>
                  <span> <i>Online</i></span>
                </div>
              </div>
              <br/>
 
 
              <div className="top_text" style={{textAlign: 'justify'}}> 
             This session of Winpe’s  <b>PEVC Career Talk Series</b> was held on <b>17th May 2025</b>, offering participants a
glimpse into the career dynamics in the organizational landscape of the Private Equity and Venture
Capital (PEVC) industry. The session received <b>great positive feedback where 100% of the participants found the session and its contents to be valuable.</b>
<br/><br/>
 
Here is a <a href="https://youtu.be/lWDNdDF4Xt8" target="_blank" style={{color:'blue', textDecoration:'underline'}}>link</a> to the recording of the session.

<br/><br/>
Focusing on the theme <b>“Understanding PEVC Culture: Career Progression and Promotion
Paths,”</b> the session explored how professionals grow within PEVC firms, what defines success, how
performance is assessed, and the structures that support advancement.<br/><br/>
Speakers shared real-life insights into firm culture, team dynamics, and the pathways to leadership
roles, helping participants understand not just how to enter the industry, but how to build a sustainable
and fulfilling career within it.<br/><br/>
The cherry on the cake was the acknowledgment for Winpe’s significant work in equipping women with
the skills needed for roles in the PEVC industry

<br/><br/>


<h3><b>Key Highlights:</b></h3>
<ul><li> <h5><b>Structured Yet Competitive Progression:</b></h5>
PEVC firms typically follow a clear hierarchy—Analyst, Associate, Vice President, Principal, and Partner—but progression is highly performance-driven. Advancing requires not just tenure but demonstrated deal execution, origination ability, and firm fit.
</li>


<li><h5><b>Deal Experience is Currency:</b></h5> 
Success and promotion are often tied to your ability to contribute meaningfully to deals. This
includes sourcing, diligence, execution, and portfolio management. The more you build a track
record of successful investments, the faster you progress.</li>


<li>
<h5><b>Cultural Fit and Relationship Building Matter:</b></h5>
Promotion isn’t just about technical skills—it also depends on how well you align with the firm’s
culture, values, and leadership. Building trust with senior partners, LPs, and portfolio founders is
crucial.</li>


<li>
<h5><b>Mentorship Matters:</b></h5>
Mentorship can be a key enabler for career advancement. One can seek mentors even through cold emails and get advice on how to navigate challenges and opportunities in the industry.</li>


<li>
<h5><b>Path to Partnership Varies by Firm:</b></h5>
Reaching Partner level is a long-term game and varies by firm structure. Some firms promote
internally based on merit and longevity, while others bring in lateral hires with sector expertise or
strong networks.</li>

<li>
<h5><b>Promotions Tied to Fund Performance:</b></h5>
In many domestic PEVC firms, career progression is heavily influenced by how the fund
performs—often up to 50% of promotion decisions are based on fund outcomes. Unlike global
firms with more standardized promotion tracks, this creates a stronger link between team
success and individual advancement.</li>


<li>
<h5><b>Principal Role should Mirror Early Partner Responsibilities:</b></h5>
At the Principal level, expectations go beyond execution—you're expected to act like a Partnerin-waiting. This includes owning deals, managing portfolio companies and exits, holding board seats, contributing to firm branding, and increasingly engaging with LPs and fundraising.
Principals are also seen as sector thought leaders and are often granted authority to write
smaller checks, signaling readiness for partnership.
</li>

</ul>
 <br/>
Q&A included questions on long-term growth opportunities in PEVC and the skills and mindset needed
to thrive. 
<br/> 



              </div>
              <br />

              
           
<br/>  

<div class="row">
  
<div class="col-md-12"> 
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Speakers</h2>          <div class="r_btm"></div>
                      
                 
                      <div className="Our_Speakers container">
                        <center>
                          <div className="Speakers_img" style={{ width: '100%' }}>
                          <div className="row">

{this.Speaker1.map((item, i) => {
 if(i<=2) 
 {
  return (
    <div
      className="main_speaker_card col-md-3 col-sm-12 col-lg-36"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
 }
 else 
 return (
    <div
      className="main_speaker_card col-md-3 col-sm-12 col-lg-3"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
})}
</div>
                          </div>

                        </center>
                      </div>
                 </div>   
                 
                  <div class="col-md-12"> 
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Moderator</h2>          <div class="r_btm"></div>
                      
                 
                      <div className="Our_Speakers container">
                        <center>
                          <div className="Speakers_img" style={{ width: '100%' }}>
                          <div className="row">

{this.Speaker2.map((item, i) => {
 if(i<=2) 
 {
  return (
    <div
      className="main_speaker_card col-md-12 col-sm-12 col-lg-12"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
 }
 else 
 return (
    <div
      className="main_speaker_card col-md-6 col-sm-6 col-lg-6"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
})}
</div>
                          </div><br /><br />

                        </center>
                      </div>
</div>
</div>

            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/PEVC-Career-Talk-Session2/index.js